import usei18n from "@app-i18n/index";
import { attractionsCartPage, attractionsOfferDetail, isMultiAttractionRoute } from "@app-router/routes/attractions";
import useAttractionReservationStore from "@app-store/multi-attraction/attraction-reservation";
import { modalEmpty } from "@app-utilities/modals";
import { QModal } from "@qamf/lighthouse";
import { BNavItem } from "bootstrap-vue-next";
import { computed, defineComponent, h } from "vue";
import { useRoute, useRouter } from "vue-router";

/**
 * Returns true when the given route name is a MA page that should show the MA cart icon.
 * Imported by service-menu.ts to centralise visibility logic and prevent a duplicate bowling cart icon.
 */
export function canShowMultiAttractionCart(routeName: string | symbol | null | undefined): boolean {
	return isMultiAttractionRoute(routeName);
}

export default defineComponent({
	name: "MultiAttractionCartEntry",
	components: {
		BNavItem,
		QModal
	},
	setup() {
		const router = useRouter();
		const route = useRoute();
		const { translateKey } = usei18n();
		const attractionReservationStore = useAttractionReservationStore();
		const isActive = computed(() => route.name === attractionsCartPage);
		const reservationId = computed(() => {
			if (typeof route.params.reskey === "string") return route.params.reskey;
			if (attractionReservationStore.reservationId) return attractionReservationStore.reservationId.toString();
			return undefined;
		});

		function goToCart() {
			router.push({
				name: attractionsCartPage,
				params: {
					companyId: route.params.companyId,
					systemId: route.params.systemId,
					...(reservationId.value ? { reskey: reservationId.value } : {})
				},
				query: route.query
			}).catch(() => { });
		}

		const showConfirmBeforeLeavingModal = async() => {
			const content = [
				h("div", translateKey("this_attraction_is_not")),
				h("div", translateKey("if_you_leave_now")),
			];
			const result = await modalEmpty(content, {
				title: translateKey("confirm_before_leaving"),
				modalClass: "confirm-before-leaving-modal",
				footerClass: "footer-modal",
				okTitle: translateKey("go_to_cart"),
				okVariant: "primary",
				cancelTitle: translateKey("continue_booking"),
				cancelVariant: "outline-primary",
			})
			if(result) goToCart();
		}

		function attemptGoToCart() {
			if(route.name === attractionsCartPage) return window.location.reload();
			if(route.name === attractionsOfferDetail) return showConfirmBeforeLeavingModal();
			goToCart();
		}

		return {
			isActive,
			goToCart,
			attemptGoToCart,
			showConfirmBeforeLeavingModal,
		};
	}
});
